module.exports = __webpack_public_path__ + "img/team-access.137a1a51.svg";